/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pcr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A single premixed tube of all reagents common to your reactions, aliquoted equally so every tube is identical and you pipette fewer times.`)
};

const es_pcr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un único tubo premezclado con todos los reactivos comunes a tus reacciones, repartido a partes iguales para que cada tubo sea idéntico y pipetees menos veces.`)
};

const de_pcr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein einzelnes vorgemischtes Röhrchen aller in Ihren Reaktionen gemeinsamen Reagenzien, das zu gleichen Teilen aliquotiert wird, sodass jedes Röhrchen identisch ist und Sie seltener pipettieren müssen.`)
};

const nl_pcr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eén vooraf gemengd buisje met alle reagentia die alle reacties gemeen hebben, gelijkmatig verdeeld zodat elk buisje identiek is en u minder vaak hoeft te pipetteren.`)
};

const fr_pcr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un tube unique prémélangé contenant tous les réactifs communs à vos réactions, réparti en quantités égales pour que chaque tube soit identique et que vous pipetiez moins souvent.`)
};

const it_pcr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un'unica provetta premiscelata con tutti i reagenti comuni alle reazioni, distribuita in parti uguali così ogni provetta è identica e si pipetta meno volte.`)
};

const pt_br2_pcr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um único tubo pré-misturado com todos os reagentes comuns às suas reações, distribuído em partes iguais para que cada tubo seja idêntico e você pipete menos vezes.`)
};

const pt_pcr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um único tubo pré-misturado com todos os reagentes comuns às reações, distribuído em partes iguais para que cada tubo seja idêntico e se pipete menos vezes.`)
};

const ja_pcr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各反応に共通するすべての試薬をあらかじめひとつのチューブに混合したもので、等量ずつ分注することですべてのチューブを均一にし、ピペッティング回数を減らせます。`)
};

const zh_pcr_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将各反应共用的所有试剂预先混合于一管中，再等量分装，使每管完全一致，同时减少移液次数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pcr_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pcr_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pcr_faq_a1", locale)
	if (locale === "en") return en_pcr_faq_a1(inputs)
	if (locale === "es") return es_pcr_faq_a1(inputs)
	if (locale === "de") return de_pcr_faq_a1(inputs)
	if (locale === "nl") return nl_pcr_faq_a1(inputs)
	if (locale === "fr") return fr_pcr_faq_a1(inputs)
	if (locale === "it") return it_pcr_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_pcr_faq_a1(inputs)
	if (locale === "pt") return pt_pcr_faq_a1(inputs)
	if (locale === "ja") return ja_pcr_faq_a1(inputs)
	return zh_pcr_faq_a1(inputs)
};